import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { useAuthState } from "./AuthStateContext";

function SessionRestoreFailure() {
  const { retrySessionRestore } = useAuthState();

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        px: 2,
        py: 6,
        textAlign: "center",
      }}
    >
      <Typography variant="body1" component="p">
        Couldn't reach Ouro — check your connection
      </Typography>
      <Button variant="outlined" onClick={retrySessionRestore}>
        Retry
      </Button>
    </Box>
  );
}

export default function ProtectedRoute({
  component: Component,
  ...routeProps
}) {
  const {
    hasStoredToken,
    autoLoginInProgress,
    performLogout,
    sessionRestoreFailed,
  } = useAuthState();

  return (
    <Route
      {...routeProps}
      render={(props) => {
        if (performLogout || (!hasStoredToken && !autoLoginInProgress)) {
          return <Redirect to="/" />;
        }

        if (sessionRestoreFailed) {
          return <SessionRestoreFailure />;
        }

        if (hasStoredToken && autoLoginInProgress) {
          return <Box sx={{ flex: 1 }} />;
        }

        return <Component {...props} />;
      }}
    />
  );
}

ProtectedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};
